module.exports = __webpack_public_path__ + "img/and-more.05ac2c5f.svg";